//On scroll
$( document ).ready(function() {
  $(window).scroll(function(){
    // Loop over each container, and check if it's visible.
    $('[id^=position]').each(function(){

      // Is this element visible onscreen?
      var visible = $(this).visible( true );
      if(visible){
        $('html').removeClass();
        var activeClass = $(this).attr("class");
        $(this).closest('[id^=parallax-section-]').addClass('active');
        $('html').addClass(activeClass);
      }

    });
    if ( $(window).scrollTop() <= 100){
      $('html').removeClass();
      $('html').addClass('white');
    }

  })

});
